export default __webpack_public_path__ + "media/images/amenities/desk-5428cb9574e4633c2d0ab6e9d40bfa59.jpeg";